import { Controller } from "@hotwired/stimulus"
import { application } from "./application"

export default class extends Controller {
  connect() {
    // Re-register translation controllers after Turbo updates
    const buttons = this.element.querySelectorAll('[data-controller="translation"]')
    buttons.forEach(button => {
      application.register("translation", button)
    })
  }
}
